import { Injectable, signal } from '@angular/core';
import { AbstractApiService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { ConfigResponse } from '../core/types/config-response.type';
import { LangCode } from '../core/types/langCode.enum';
import { Property } from '../core/types/property.type';
@Injectable({ providedIn: 'root' })
export class ConfigurationService extends AbstractApiService {
  constructor(http: HttpClient) {
    super(http);
  }

  configSubject = new BehaviorSubject<ConfigResponse | null>(null);
  config$ = this.configSubject.asObservable();

  langCodeSubject = new BehaviorSubject<LangCode>(LangCode.ItIT);
  langCode$ = this.langCodeSubject.asObservable();

  currentPageSubject = new BehaviorSubject<string>('');
  currentPage$ = this.currentPageSubject.asObservable();

  propertyCodeSubject = new BehaviorSubject<string>('');
  propertyCode$ = this.propertyCodeSubject.asObservable();

  logoUrl = signal('');
  config!: ConfigResponse | null;

  setLangCode(langCode: LangCode): void {
    if (langCode) this.langCodeSubject.next(langCode);
  }

  setPropertyCode(propertyCode: string): void {
    if (propertyCode) this.propertyCodeSubject.next(propertyCode);
  }

  getLogoUrl(): string {
    return this.config?.vendor?.logoUrl || '';
  }

  setLogoUrl(logoUrl: string): void {
    this.logoUrl.set(logoUrl);
  }

  getConfigValue() {
    return this.config;
  }

  setConfig(config: ConfigResponse): void {
    this.config = this.normalize(config);
    this.configSubject.next(this.config);
  }

  // Fix issues with old configurations
  normalize(config: ConfigResponse & { property?: Property }): ConfigResponse {
    if( !config.vendor && config.property ) {
      config.vendor = config.property
    }

    if( !config.vendor.code && config.vendor.propertyCode ) {
      config.vendor.code = config.vendor.propertyCode;
    }
    delete config.property
    return config;
  }

  getConfig(propertyCode: string, langCode: string): Observable<ConfigResponse> {
    const url = `${this.getBaseUrl()}/config/${propertyCode}/${langCode}.json`;
    return this.http.get<ConfigResponse & { property?: Property }>(url).pipe(
      map(raw => this.normalize(raw)),
      catchError(err => {
        console.error('Error fetching configuration:', err);
        return throwError(() => err);
      })
    );
  }
}
